import React from 'react';
import PropTypes from 'prop-types';

import { isClient } from '../../utils/device-utils';

const Placeholder = (): React.ReactNode => null;

export interface INoSSR {
  children?: React.ReactNode;
  placeholder?: React.ReactNode;
  skip?: boolean;
}

const NoSSR: React.FC<INoSSR> = ({ children, placeholder = Placeholder(), skip = false }): React.ReactElement => {
  const shouldSkip: boolean = skip || isClient();
  return <React.Fragment>{shouldSkip ? children : placeholder}</React.Fragment>;
};
/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  NoSSR.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    placeholder: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    skip: PropTypes.bool,
  };
}

export default NoSSR;
